<template>
  <div class="menu-page">
    <div class="menu-box">
      <ul class="up">
        <li @click="goPage('/')">
          <div class="icon"><img src="../assets/menu_page/icon1.png" /></div>
          <div class="text">基本客情</div>
        </li>
        <li @click="goPage('/juminchuyou')">
          <div class="icon"><img src="../assets/menu_page/icon2.png" /></div>
          <div class="text">出游客情</div>
        </li>
        <li @click="goPage('/ziyuanpinggu')">
          <div class="icon"><img src="../assets/menu_page/icon3.png" /></div>
          <div class="text">资源评估</div>
        </li>
        <li>
          <div class="icon"><img src="../assets/menu_page/icon4.png" /></div>
          <div class="text">网络行为</div>
        </li>
      </ul>
      <ul class="down">
        <li>
          <div class="icon"><img src="../assets/menu_page/icon5.png" /></div>
          <div class="text">目的地口碑</div>
        </li>
        <li>
          <div class="icon"><img src="../assets/menu_page/icon6.png" /></div>
          <div class="text">全域旅游</div>
        </li>
        <li>
          <div class="icon"><img src="../assets/menu_page/icon7.png" /></div>
          <div class="text">主题游</div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {
    goPage(router) {
      this.$router.push({ path: router });
    }
  }
};
</script>
<style scoped lang="less">
.menu-page {
  width: 100%;
  height: 100%;
  background: url(../assets/menu_page/menu_bg.jpg);
  background-size: 100% 100%;
  overflow: hidden;
  .menu-box {
    width: 12.8rem;
    height: 6.4rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -6.4rem;
    margin-top: -3rem;
    font-size: 0.28rem;
    font-weight: bold;
    color: base-text-color;
    text-shadow: 0px 0px 0.08rem #30b4ff;
    > ul {
      width: 100%;
      height: 50%;
      margin-top: 0.1rem;
      li {
        float: left;
        cursor: pointer;
        .icon {
          width: 1.2rem;
          height: 1.2rem;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .text {
          width: 2.58rem;
          height: 0.79rem;
          margin: 0 auto;
          line-height: 0.81rem;
          background: url(../assets/menu_page/border.png);
          background-size: 100% 100%;
        }
      }
    }
    .up {
      li {
        width: 25%;
      }
    }
    .down {
      width: 75%;
      margin: 0 auto;
      li {
        width: 33.3333%;
      }
    }
  }
}
</style>
